import type { DoctorListItem } from '@dermalink/shared';

/** Portrait URL when the doctor has uploaded a profile picture; otherwise null (use initials in UI). */
export function doctorPortraitUrl(
  doctor: Pick<DoctorListItem, 'picture_url'>,
): string | null {
  return doctor.picture_url ?? null;
}
